import { Box, Button, Flex, Loading, Message } from 'components/ui';
import Page from 'components/layout/Page';
import { useCollectionStats } from 'hooks/apiTokensService';
import FuturaGalleryView from 'components/FuturaGalleryView';
import { platformCollectionIds, remixEnabled } from 'utils/config';
import { REQUEST_STATUS } from '../../constants';
import { Link } from 'react-router-dom';
import exploreFuturaBg from 'img/explore-futura-section-bg.png';
import SectionWrapper from 'components/ui/SectionWrapper';
import futuraGlobalTraits from 'img/futura-global-traits.svg';
import SectionTitle from 'components/ui/SectionTitle';

const FuturaGallery = () => {
  const { collectionStats, status } = useCollectionStats(platformCollectionIds.futura);

  return (
    <Page title="Futura Gallery" padding="0" background="#1C1C1C" fixedFooter={false}>
      <Box
        width="100%"
        height="64px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px="40px"
        position="relative"
        backgroundColor="#AF0057"
      >
        <Box>
          <Box fontSize="16px" lineHeight={1.375} fontWeight={400} display="inline">
            Create a new remix with your Futura NFTs.
          </Box>
          <Box
            fontSize="16px"
            lineHeight={1.375}
            fontWeight={600}
            display={['none', 'inline']}
            ml={2}
          >
            Try Remix Studio {remixEnabled ? 'now!' : 'soon!'}
          </Box>
        </Box>

        {remixEnabled ? (
          <Link to="/futura/remix">
            <Button
              color="white"
              bg="black"
              border="1px solid white"
              disabled={!remixEnabled}
              maxHeight="44px"
            >
              Try Remix Studio
            </Button>
          </Link>
        ) : (
          <Button
            color="white"
            bg="black"
            border="1px solid white"
            disabled={!remixEnabled}
            maxHeight="44px"
          >
            Try Remix Studio
          </Button>
        )}
      </Box>

      <SectionWrapper
        height="264px"
        backgroundImage={`url(${exploreFuturaBg})`}
        backgroundPosition="center"
        backgroundSize="cover"
        pl="40px"
        pr="24px"
      >
        <Box py={['16px', '40px']}>
          <SectionTitle fontWeight={700} fontSize="32px">
            Discover Futura
          </SectionTitle>
          <Box
            mt={2}
            mb={4}
            width="100%"
            maxWidth="440px"
            fontSize="16px"
            lineHeight={1.375}
            fontWeight={400}
          >
            Explore Futura Traits to understand the unique characteristics of your NFTs
          </Box>
          <Flex flexDirection={['column', 'row']}>
            <Link to="/futura/traits">
              <Button
                mb={2}
                mr={3}
                color="white"
                bg="black"
                outlined
                maxHeight="36px"
                width="200px"
              >
                Explore Futura traits
              </Button>
            </Link>
            <a
              href="https://eulerbeats.gitbook.io/eulerbeats-docs/futura"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button mb={2} color="white" bg="black" outlined maxHeight="36px" width="200px">
                Futura FAQ
              </Button>
            </a>
          </Flex>
        </Box>
        <Box maxWidth="512px" zIndex={5} display={['none', 'block']}>
          <img src={futuraGlobalTraits} alt="Remix Studio" width="100%" />
        </Box>
      </SectionWrapper>

      <Box>
        {status === REQUEST_STATUS.loading && (
          <Box width="100%" textAlign="center">
            <Loading />
          </Box>
        )}

        {status === REQUEST_STATUS.error && (
          <Message width="100%" maxWidth="320px" margin="2em auto" color="black">
            Error loading items
          </Message>
        )}

        {status === REQUEST_STATUS.success && (
          <FuturaGalleryView collectionStats={collectionStats} />
        )}
      </Box>
    </Page>
  );
};

export default FuturaGallery;
